<script setup lang="ts">
import { BauabschnittDetail } from "@/types";
import { computed, defineEmits, defineProps } from "vue";

type Props = {
  strings: number | null | undefined;
  moduleFields: number | null | undefined;
  bauabschnitt: number | null | undefined;
  bauabschnittDetails: BauabschnittDetail[] | null | undefined;
};

type Emits = {
  (event: "openModal", input: any): void;
};

const props = defineProps<Props>();
const emits = defineEmits<Emits>();

const onOpenModal = (input: any) => {
  emits("openModal", input);
};

let inputs = computed(() => {
  let tempInputs = [];
  if (props.bauabschnitt) {
    for (let index = 0; index < props.bauabschnitt; index++) {
      let input = props.bauabschnittDetails?.find(
        (item: any) => item.order === index + 1
      );

      if (input) {
        tempInputs.push({
          id: input.id,
          placeholder: input.name,
          value: input.name,
          order: index + 1,
          image: input.image,
        });
      } else {
        tempInputs.push({
          placeholder: `Part ${index + 1}`,
          value: "",
          order: index + 1,
        });
      }
    }
  }
  tempInputs.sort((a: any, b: any) => a.order - b.order);
  return tempInputs;
});
</script>

<template>
  <div>
    <div class="grid grid-cols-2 gap-2">
      <div
        class="w-full border border-[#E3E1EA] p-2 rounded-primary-radius flex items-center gap-2"
      >
        <p
          class="w-[34px] h-[34px] flex items-center justify-center rounded-full bg-[#E8E7FB]"
        >
          {{ strings }}
        </p>
        <p>Strings</p>
      </div>
      <div
        class="w-full border border-[#E3E1EA] p-2 rounded-primary-radius flex items-center gap-2"
      >
        <p
          class="w-[34px] h-[34px] flex items-center justify-center rounded-full bg-[#E8E7FB]"
        >
          {{ moduleFields }}
        </p>
        <p>Module field</p>
      </div>
    </div>
    <!-- Inputs container -->
    <div class="mt-2">
      <div class="w-full border border-[#E3E1EA] p-2 rounded-primary-radius">
        <div class="w-full flex items-center gap-2">
          <p
            class="w-[34px] h-[34px] flex items-center justify-center rounded-full bg-[#E8E7FB]"
          >
            {{ bauabschnitt }}
          </p>
          <p>Bauabschnitt</p>
        </div>
        <!-- Inputs -->
        <div class="h-[102px] overflow-y-auto mt-[10px]">
          <div class="flex flex-col gap-2">
            <!-- Empty inputs -->
            <div v-if="inputs" class="flex flex-col gap-2">
              <div
                v-for="input in inputs"
                :key="input.id"
                class="flex flex-col"
              >
                <div
                  @click="onOpenModal(input)"
                  class="w-full flex items-center justify-between px-3 py-[10px] rounded-primary-radius hover:cursor-pointer transition-all duration-200 ease-in-out"
                  :class="
                    !input.value
                      ? 'border border-[#ED857F] bg-transparent'
                      : 'border border-[#E3E1EA] bg-[#F9F8F6]'
                  "
                >
                  <input
                    type="text"
                    :placeholder="input.placeholder"
                    :value="input.value"
                    readonly
                    class="w-full outline-none text-base text-primary-text-color font-normal tracking-[0.01rem] bg-transparent placeholder:text-primary-text-color hover:cursor-pointer"
                  />

                  <div
                    v-if="input.value"
                    class="flex items-center justify-center"
                  >
                    <img
                      class="w-5"
                      src="@/assets/edit-pencil-technical.svg"
                      alt="Edit"
                    />
                  </div>
                  <div v-else class="flex items-center justify-center">
                    <img
                      class="w-5 h-5"
                      src="@/assets/add-plus-circle-grey.svg"
                      alt="Add"
                    />
                  </div>
                </div>
                <div
                  v-if="!input.value"
                  class="flex items-center gap-1 mt-1 hover:cursor-pointer"
                >
                  <img src="@/assets/warning-red-rounded.svg" alt="" />
                  <span class="text-sm text-[#ED857F]"
                    >Title and image required</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
